import React from "react";

const Footer = () => {
  return (
      <footer className='bg-black wow animate__animated animate__fadeInUp'>
          <div className='container'>
              <div className='footer-top bg-primary wow animate__animated animate__zoomIn'>
                  <div className='row align-items-center row-gap-3'>
                      <div className='col-md-4 col-lg-4 col-xl-2'>
                          <div className='footer-logo'>
                              <img
                                  src="/assets/images/logo.png"
                                  alt="Logo"
                                  className="img-fluid"
                              />
                          </div>
                      </div>
                      <div className='col-md-8 col-lg-8 col-xl-10'>
                          <div className='footer-contact'>
                              <div className='fc-box'>
                                  <div className='fc-icon'>
                                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                           xmlns="http://www.w3.org/2000/svg">
                                          <path
                                              d="M11.6578 8.47962L9.03274 7.35461C8.9206 7.30681 8.79597 7.29674 8.67761 7.32591C8.55925 7.35508 8.45357 7.4219 8.37648 7.51633L7.21396 8.93666C5.38949 8.07645 3.92121 6.60817 3.06099 4.7837L4.48133 3.62118C4.57594 3.54423 4.64291 3.43855 4.67209 3.32013C4.70127 3.20172 4.69108 3.07702 4.64305 2.96492L3.51803 0.339872C3.46532 0.219028 3.3721 0.120363 3.25444 0.0608898C3.13677 0.00141686 3.00205 -0.0151363 2.87349 0.0140846L0.435945 0.576595C0.311998 0.605217 0.201413 0.675005 0.122237 0.774571C0.0430614 0.874136 -2.85523e-05 0.997599 1.41945e-08 1.12481C1.41945e-08 7.13663 4.87274 12 10.8752 12C11.0024 12.0001 11.126 11.957 11.2256 11.8778C11.3252 11.7987 11.395 11.688 11.4236 11.5641L11.9862 9.12651C12.0152 8.99733 11.9983 8.86206 11.9383 8.74399C11.8784 8.62593 11.7792 8.53244 11.6578 8.47962Z"
                                              fill="white"/>
                                      </svg>
                                  </div>
                                  <div className='fc-text'>
                                      <a href='tel:00 123 456 7890' className='text-black'>
                                          +00 123 456 7890
                                      </a>
                                  </div>

                              </div>
                              <div className='fc-box'>
                                  <div className='fc-icon'>
                                      <svg width="12" height="9" viewBox="0 0 12 9" fill="none"
                                           xmlns="http://www.w3.org/2000/svg">
                                          <path
                                              d="M11.7727 2.97188C11.8641 2.89922 12 2.96719 12 3.08203V7.875C12 8.49609 11.4961 9 10.875 9H1.125C0.503906 9 0 8.49609 0 7.875V3.08438C0 2.96719 0.133594 2.90156 0.227344 2.97422C0.752344 3.38203 1.44844 3.9 3.83906 5.63672C4.33359 5.99766 5.16797 6.75703 6 6.75234C6.83672 6.75938 7.6875 5.98359 8.16328 5.63672C10.5539 3.9 11.2477 3.37969 11.7727 2.97188ZM6 6C6.54375 6.00938 7.32656 5.31563 7.72031 5.02969C10.8305 2.77266 11.0672 2.57578 11.7844 2.01328C11.9203 1.90781 12 1.74375 12 1.57031V1.125C12 0.503906 11.4961 0 10.875 0H1.125C0.503906 0 0 0.503906 0 1.125V1.57031C0 1.74375 0.0796875 1.90547 0.215625 2.01328C0.932813 2.57344 1.16953 2.77266 4.27969 5.02969C4.67344 5.31563 5.45625 6.00938 6 6Z"
                                              fill="white"/>
                                      </svg>

                                  </div>
                                  <div className='fc-text'>
                                      <a href='mailto:info@prime4.0.com' className='text-black'>
                                          info@kosmiclab.com
                                      </a>
                                  </div>

                              </div>
                              <div className='fc-box'>
                                  <div className='fc-icon'>
                                      <svg width="10" height="12" viewBox="0 0 10 12" fill="none"
                                           xmlns="http://www.w3.org/2000/svg">
                                          <path
                                              d="M5.06859 11.7304C6.27405 10.2218 9.02335 6.56543 9.02335 4.51168C9.02335 2.02085 7.0025 0 4.51168 0C2.02085 0 0 2.02085 0 4.51168C0 6.56543 2.7493 10.2218 3.95477 11.7304C4.2438 12.0899 4.77956 12.0899 5.06859 11.7304ZM4.51168 3.00778C4.91053 3.00778 5.29305 3.16623 5.57509 3.44826C5.85712 3.7303 6.01557 4.11282 6.01557 4.51168C6.01557 4.91053 5.85712 5.29305 5.57509 5.57509C5.29305 5.85712 4.91053 6.01557 4.51168 6.01557C4.11282 6.01557 3.7303 5.85712 3.44826 5.57509C3.16623 5.29305 3.00778 4.91053 3.00778 4.51168C3.00778 4.11282 3.16623 3.7303 3.44826 3.44826C3.7303 3.16623 4.11282 3.00778 4.51168 3.00778Z"
                                              fill="white"/>
                                      </svg>

                                  </div>
                                  <div className='fc-text'>
                                      <p>
                                          87 Park Road, Wigan, England, WN6 7AE
                                      </p>
                                  </div>

                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div className='footer-middle'>
                  <div className='row row-gap-3'>
                      <div className='col-md-6 col-lg-4'>
                          <div className='footer-box'>
                              <h3 className='text-primary'>Products</h3>
                              <ul>
                                  <li><a href='/NetworkImplementation'>Network Implementation</a></li>
                                  <li><a href='#'>Security Solutions</a></li>
                                  <li><a href='#'>Multi-Cloud Services</a></li>
                                  <li><a href='#'>Observability & Infra Automation</a></li>
                                  <li><a href='#'>Base Station Services</a></li>
                                  <li><a href='#'>AI Business Automation</a></li>
                              </ul>
                          </div>
                      </div>
                      <div className='col-md-6 col-lg-4'>
                          <div className='footer-box'>
                              <h3 className='text-primary'>Company</h3>
                              <div className='row'>
                                  <div className='col-md-6'>
                                      <ul>
                                          <li><a href='/'>Home</a></li>
                                          <li><a href='/about'>About Us</a></li>
                                          <li><a href='#'>Case Studies</a></li>
                                          <li><a href='#'>Latest Blogs</a></li>
                                          <li><a href='#'>We hiring!</a></li>
                                          <li><a href='#'>Contact Us</a></li>
                                      </ul>
                                  </div>
                                  <div className='col-md-6'>
                                      <ul>
                                          <li><a href='#'>Terms & Conditions</a></li>
                                          <li><a href='#'>Privacy policy</a></li>
                                          <li><a href='#'>cookies policy</a></li>
                                          <li><a href='#'>Whitepapers</a></li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className='col-md-12 col-lg-4'>
                          <div className='footer-box'>
                              <h3 className='text-primary'>Newsletter</h3>
                              <div className={'newsletter-box'}>
                                  <p className={'text-white mb-3'}>
                                      Get the latest updates on tech trends, innovations, and smart solutions—straight
                                      to your inbox.
                                  </p>
                                  <div className={'newsbox position-relative'}>
                                      <input className={'form-control'} placeholder="Email"/>
                                      <button className={'btn btn-primary'}>Submit</button>
                                  </div>

                              </div>


                          </div>
                      </div>


                  </div>
              </div>

          </div>
          <div className='footer-bottom'>
              <div className='container'>
                  <div className='row'>
                      <div className='col-md-4'>
                          <div className='footer-social justify-content-start'>
                              <a href='#' target='_blank' title='instagram'>
                                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_9_326)">
                                          <path
                                              d="M8.00179 4.05684C5.73162 4.05684 3.9005 5.88797 3.9005 8.15813C3.9005 10.4283 5.73162 12.2594 8.00179 12.2594C10.2719 12.2594 12.1031 10.4283 12.1031 8.15813C12.1031 5.88797 10.2719 4.05684 8.00179 4.05684ZM8.00179 10.8245C6.53475 10.8245 5.33542 9.62874 5.33542 8.15813C5.33542 6.68752 6.53118 5.49176 8.00179 5.49176C9.47239 5.49176 10.6682 6.68752 10.6682 8.15813C10.6682 9.62874 9.46882 10.8245 8.00179 10.8245ZM13.2274 3.88908C13.2274 4.42093 12.7991 4.84569 12.2708 4.84569C11.739 4.84569 11.3142 4.41736 11.3142 3.88908C11.3142 3.3608 11.7426 2.93247 12.2708 2.93247C12.7991 2.93247 13.2274 3.3608 13.2274 3.88908ZM15.9438 4.85997C15.8831 3.57854 15.5904 2.44346 14.6516 1.50827C13.7165 0.573074 12.5814 0.280381 11.2999 0.216131C9.97925 0.141173 6.02075 0.141173 4.70006 0.216131C3.4222 0.276811 2.28712 0.569505 1.34835 1.5047C0.409593 2.43989 0.120468 3.57497 0.0562186 4.8564C-0.0187395 6.17709 -0.0187395 10.1356 0.0562186 11.4563C0.116899 12.7377 0.409593 13.8728 1.34835 14.808C2.28712 15.7432 3.41863 16.0359 4.70006 16.1001C6.02075 16.1751 9.97925 16.1751 11.2999 16.1001C12.5814 16.0394 13.7165 15.7467 14.6516 14.808C15.5868 13.8728 15.8795 12.7377 15.9438 11.4563C16.0187 10.1356 16.0187 6.18066 15.9438 4.85997ZM14.2376 12.8734C13.9592 13.573 13.4202 14.1119 12.717 14.3939C11.664 14.8116 9.16542 14.7152 8.00179 14.7152C6.83815 14.7152 4.33597 14.808 3.28656 14.3939C2.58695 14.1155 2.04796 13.5765 1.76598 12.8734C1.34835 11.8204 1.44473 9.32176 1.44473 8.15813C1.44473 6.99449 1.35192 4.49232 1.76598 3.4429C2.04439 2.74329 2.58338 2.20431 3.28656 1.92232C4.33954 1.5047 6.83815 1.60107 8.00179 1.60107C9.16542 1.60107 11.6676 1.50827 12.717 1.92232C13.4166 2.20074 13.9556 2.73972 14.2376 3.4429C14.6552 4.49589 14.5588 6.99449 14.5588 8.15813C14.5588 9.32176 14.6552 11.8239 14.2376 12.8734Z"
                                              fill="white"/>
                                      </g>
                                      <defs>
                                          <clipPath id="clip0_9_326">
                                              <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                                          </clipPath>
                                      </defs>
                                  </svg>

                              </a>
                              <a href='#' target='_blank' title='linkedin'>
                                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                      <path
                                          d="M3.58214 16.5H0.264286V5.81786H3.58214V16.5ZM1.92143 4.36071C0.860714 4.36071 0 3.48214 0 2.42143C0 1.91183 0.202436 1.42311 0.562773 1.06277C0.923111 0.702436 1.41183 0.5 1.92143 0.5C2.43102 0.5 2.91975 0.702436 3.28008 1.06277C3.64042 1.42311 3.84286 1.91183 3.84286 2.42143C3.84286 3.48214 2.98214 4.36071 1.92143 4.36071ZM15.9964 16.5H12.6857V11.3C12.6857 10.0607 12.6607 8.47143 10.9607 8.47143C9.23571 8.47143 8.97143 9.81786 8.97143 11.2107V16.5H5.65714V5.81786H8.83929V7.275H8.88571C9.32857 6.43571 10.4107 5.55 12.025 5.55C15.3821 5.55 16 7.76072 16 10.6321V16.5H15.9964Z"
                                          fill="white"/>
                                  </svg>

                              </a>
                              <a href='#' target='_blank' title='facebook'>
                                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_9_328)">
                                          <path
                                              d="M12.0078 9.23022L12.4522 6.3346H9.67375V4.45554C9.67375 3.66335 10.0619 2.89116 11.3063 2.89116H12.5694V0.42585C12.5694 0.42585 11.4231 0.230225 10.3272 0.230225C8.03906 0.230225 6.54344 1.6171 6.54344 4.12772V6.3346H4V9.23022H6.54344V16.2302H9.67375V9.23022H12.0078Z"
                                              fill="white"/>
                                      </g>
                                      <defs>
                                          <clipPath id="clip0_9_328">
                                              <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                                          </clipPath>
                                      </defs>
                                  </svg>

                              </a>
                              <a href='#' target='_blank' title='x'>
                                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                      <path
                                          d="M12.1635 2H14.3698L9.551 7.50625L15.2198 15H10.7823L7.30413 10.4563L3.32913 15H1.11975L6.27288 9.10938L0.838501 2H5.3885L8.52913 6.15312L12.1635 2ZM11.3885 13.6812H12.6104L4.72288 3.25H3.41038L11.3885 13.6812Z"
                                          fill="white"/>
                                  </svg>

                              </a>
                          </div>
                      </div>
                      <div className='col-md-8'>
                          <div className='copyright-text text-end'>
                              <small className='text-white'>© Copyright 2025 Kosmic Lab. All rights reserved.</small>
                          </div>
                      </div>

                  </div>
              </div>
          </div>
      </footer>
  );
};

export default Footer;
